import { Store } from "../../store/store"
import { KnowledgeBaseHub } from "./knowledgeBase"

export class SharedKnowledgeBaseHub extends KnowledgeBaseHub {
    constructor(store: Store) {
        super(store, "/shared-knowledge-base-hub")
    }
}
